import { Link } from "react-router-dom";
import {
  Smartphone, Monitor, Wifi, Camera, Printer, KeyRound, GraduationCap,
  CheckCircle2, Phone,
} from "lucide-react";
import { SERVICES, CONTACT } from "../data";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CTABand } from "../components/CTABand";

const ICONS = { Smartphone, Monitor, Wifi, Camera, Printer, KeyRound, GraduationCap };

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Our Services"
        title="Help with all your everyday technology"
        subtitle="Whatever's giving you trouble, we can help. Clear pricing, patient service, and plain‑English explanations every step of the way."
      >
        <a
          href={CONTACT.phoneHref}
          data-testid="services-call-now"
          className="mt-8 inline-flex items-center gap-2 h-14 px-8 rounded-full bg-accent text-white font-bold text-lg hover:bg-[hsl(196,82%,27%)] transition-colors"
        >
          <Phone className="h-5 w-5" /> Call {CONTACT.phone}
        </a>
      </PageHero>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28 space-y-6">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.slug} delay={(i % 2) * 0.06}>
              <div
                data-testid={`service-card-${s.slug}`}
                className="rounded-2xl border border-border bg-card p-8 lg:p-10 grid lg:grid-cols-[auto,1fr,auto] gap-8 items-center hover:border-accent/40 transition-colors"
              >
                <span className="grid place-items-center h-16 w-16 rounded-2xl bg-primary text-white shrink-0">
                  <Icon className="h-8 w-8" />
                </span>
                <div>
                  <h2 className="font-heading font-bold text-2xl text-foreground mb-2">{s.title}</h2>
                  <p className="text-muted-foreground text-lg leading-relaxed mb-4">{s.short}</p>
                  <ul className="grid sm:grid-cols-3 gap-2">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-start gap-2 text-slate-300">
                        <CheckCircle2 className="h-5 w-5 text-accent shrink-0 mt-0.5" />
                        <span>{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <Link
                  to="/contact"
                  data-testid={`service-book-${s.slug}`}
                  className="inline-flex items-center justify-center h-14 px-7 rounded-full bg-accent/10 text-accent font-bold hover:bg-accent hover:text-white transition-colors whitespace-nowrap"
                >
                  Book this
                </Link>
              </div>
            </Reveal>
          );
        })}
      </div>

      <CTABand />
    </div>
  );
}
